export const microsoftConstants = {
  FETCH_MICROSOFT_EMAIL_THREADS_REQUEST: "FETCH_MICROSOFT_EMAIL_THREADS_REQUEST",
  FETCH_MICROSOFT_EMAIL_THREADS_SUCCESS: "FETCH_MICROSOFT_EMAIL_THREADS_SUCCESS",
  FETCH_MICROSOFT_EMAIL_THREADS_FAILURE: "FETCH_MICROSOFT_EMAIL_THREADS_FAILURE",

  CHECK_MICROSOFT_AUTH_REQUEST: "CHECK_MICROSOFT_AUTH_REQUEST",
  CHECK_MICROSOFT_AUTH_SUCCESS: "CHECK_MICROSOFT_AUTH_SUCCESS",
  CHECK_MICROSOFT_AUTH_FAILURE: "CHECK_MICROSOFT_AUTH_FAILURE",
};
